/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactSolidComponent from '../createReactSolidComponent.js';

var DangerTriangleSolid = createReactSolidComponent("danger-triangle", "DangerTriangleSolid", [["path", { "d": "M8.583 4.507C9.538 3.159 10.582 2.25 12 2.25c1.418 0 2.462.91 3.417 2.257.948 1.338 1.953 3.318 3.24 5.852l.39.769c1.065 2.098 1.904 3.75 2.344 5.076.448 1.348.55 2.552-.121 3.623-.67 1.066-1.801 1.511-3.22 1.719-1.398.204-3.272.204-5.656.204h-.788c-2.384 0-4.258 0-5.656-.204-1.419-.208-2.55-.653-3.22-1.72-.671-1.07-.569-2.274-.12-3.622.44-1.325 1.278-2.978 2.344-5.076l.39-.768c1.286-2.535 2.29-4.515 3.24-5.853M12.75 8.5a.75.75 0 0 0-1.5 0V14a.75.75 0 0 0 1.5 0zm0 8.247a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0z", "key": "svg-0" }]]);

export { DangerTriangleSolid as default };
//# sourceMappingURL=DangerTriangleSolid.js.map
